import React, { useState } from 'react';
import './EmailSignup.css';
import MarketingConsent from './MarketingConsent';
import { submitFormspark } from '../utils/formspark';

/**
 * Site-wide email capture shown in the footer. Requires the marketing
 * consent checkbox so every address collected here is an explicit opt-in.
 */
const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [optIn, setOptIn] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // 'success', 'error', or null

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!optIn) return;

    setIsSubmitting(true);
    setStatus(null);

    try {
      await submitFormspark({
        form: 'email-signup',
        email,
        marketingOptIn: 'Yes',
        source: typeof window !== 'undefined' ? window.location.pathname : ''
      });
      setStatus('success');
      setEmail('');
      setOptIn(false);
    } catch (error) {
      console.error('Email signup error:', error);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="email-signup" aria-labelledby="email-signup-title">
      <h2 id="email-signup-title" className="email-signup-title">Stay in the loop</h2>
      <p className="email-signup-subtitle">
        Get first word on live music, trivia nights, specials, and events at Drake's.
      </p>

      {status === 'success' && (
        <div className="email-signup-message email-signup-success" role="status">
          You're on the list. Thanks for signing up!
        </div>
      )}

      {status === 'error' && (
        <div className="email-signup-message email-signup-error" role="alert">
          Sorry, something went wrong. Please try again in a moment.
        </div>
      )}

      <form className="email-signup-form" onSubmit={handleSubmit}>
        <div className="email-signup-row">
          <label htmlFor="footer-email" className="email-signup-visually-hidden">Email</label>
          <input
            type="email"
            id="footer-email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
            required
            disabled={isSubmitting}
            className="email-signup-input"
          />
          <button
            type="submit"
            className="email-signup-button"
            disabled={isSubmitting || !optIn}
          >
            {isSubmitting ? 'Signing up...' : 'Sign up'}
          </button>
        </div>

        <MarketingConsent
          id="footer-marketing-opt-in"
          checked={optIn}
          onChange={(e) => setOptIn(e.target.checked)}
          disabled={isSubmitting}
          required
        />
      </form>
    </section>
  );
};

export default EmailSignup;
